export default __webpack_public_path__ + "static/media/betnearn-ico.2ab0a165.svg";